import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { map, timeout } from 'rxjs/operators';
import { Wheels } from '../interfaces/wheels';
import { CartResponse } from '../interfaces/Cart.interface';
import { UserResponse } from '../interfaces/User.interface';
import { OrderResponse } from '../models/OrderResponse';
import { ProductDetailResponse } from '../interfaces/ProductDetailResponse';
import { SearchInterface } from '../interfaces/Search.interface';
import { PageResponse } from '../interfaces/Page.interface';
import { AddressBook, MyAccountData, MyAccountResponse } from '../interfaces/MyAccount.interface';

import { ActivatedRoute, Params, Router } from '@angular/router';


declare const require: any;
const qs = require('qs');

@Injectable({
  providedIn: 'root'
})
export class ApiServices {
  // const userData: any = JSON.parse( localStorage.getItem('ts_user_data') );

  constructor(private http: HttpClient) { }

  getAuthorizationHeader(): HttpHeaders {
    return new HttpHeaders().set('Authorization', 'Bearer ' + localStorage.getItem('ts_vendor_access_token'));
  }

  // Helper method to get API path for debugging
  getApiPath(): string {
    return environment.apiPath;
  }

  login(formData: object): Observable<UserResponse> {
    const url = environment.apiPath + 'auth/login';
    return this.http.post<UserResponse>(url, formData);
  }

  forgotPassword(formData: object): Observable<UserResponse> {
    const url = environment.apiPath + 'auth/forgot';
    return this.http.post<UserResponse>(url, formData);
  }

  resetPassword(formData: object): Observable<UserResponse> {
    const url = environment.apiPath + 'auth/reset-password';
    return this.http.post<UserResponse>(url, formData);
  }

  register(formData: object): Observable<UserResponse> {
    const url = environment.apiPath + 'dealer';
    return this.http.post<UserResponse>(url, formData);
  }

  vendorRegister(formData: object): Observable<UserResponse> {
    const url = environment.apiPath + 'vendor';
    return this.http.post<UserResponse>(url, formData);
  }
  requestVendor(vendor_code: any): Observable<any> {
    const userData = JSON.parse(localStorage.getItem('ts_user_data') || '{}');
    const userId = userData.user_data.id;
    const url = environment.apiPath + 'dealer/vendor-request?user_id=' + userId + '&vendor_code=' + vendor_code;
    // Return the direct response without additional transformations
    return this.http.get<any>(url, { headers: this.getAuthorizationHeader() });
  }
  DealerVendors(): Observable<any> {
    let uData = JSON.parse(localStorage.getItem('ts_user_data') || '{}');
    const url = environment.apiPath + 'dealer/vendors?dealer_id=' + uData.user_data.id;
    return this.http.get(url, { headers: this.getAuthorizationHeader() });
  }

  getVendorProfile(vendorId, isVendorApproved = true): Observable<any> {
    let url = environment.apiPath + 'vendor-profile/' + vendorId;
    if (!isVendorApproved) {
      url += '?preview=1'
    }
    return this.http.get(url, { headers: this.getAuthorizationHeader() });
  }

  // getProductsByCustomSize(formData = null, pagination = 1): Observable<Wheels> {
  //   const userData: any = JSON.parse( localStorage.getItem('ts_user_data') );

  //   const data = Object.assign({}, formData);
  //   data.page = pagination;
  //   let url = environment.apiPath + 'dealer/vendor-products/'+userData.user_data.id;
  //   if (data) {
  //     const query = qs.stringify(data);
  //     url += '?' + query;
  //   }

  //   return this.http.get<Wheels>(url, {headers: this.getAuthorizationHeader()});
  // }
  getProductsByCustomSize(formData: any = null, pagination = 1): Observable<Wheels> {

    const data = Object.assign({}, formData || {});
    data.pagination = pagination;
    let url = environment.apiPath + 'products';
    if (data) {
      const query = qs.stringify(data);
      url += '?' + query;
    }

    return this.http.get<Wheels>(url, { headers: this.getAuthorizationHeader() });


    // const userData: any = JSON.parse( localStorage.getItem('ts_user_data') );

    // const data = Object.assign({}, formData);
    // data.page = pagination;
    // let url = environment.apiPath + 'search-by-size';
    // if (data) {
    //   const query = qs.stringify(data);
    //   url += '?' + query;
    // }

    // return this.http.get<Wheels>(url, {headers: this.getAuthorizationHeader()});
  }
  getAllProducts(formData: any = null, pagination = 1): Observable<Wheels> {
    const data = Object.assign({}, formData || {});
    data.pagination = pagination;
    let url = environment.apiPath + 'products';
    if (data) {
      const query = qs.stringify(data);
      url += '?' + query;
    }

    return this.http.get<Wheels>(url, { headers: this.getAuthorizationHeader() });
  }


  getFilters(params: any): Observable<any> {
    const url = environment.apiPath + 'filters?' + qs.stringify(params);
    return this.http.get<any>(url, { headers: this.getAuthorizationHeader() });
  }

  getAddOnFilters(queryParams: any, catSlug: string): Observable<any> {
    const url = environment.apiPath + `add-on-filters/${catSlug}/get`;
    return this.http.get<any>(url, { headers: this.getAuthorizationHeader(), params: queryParams });
  }

  getWheelDetail(id: number, variantID: number, vendorApproved = true): Observable<ProductDetailResponse> {
    let url = environment.apiPath + 'product/' + id + '/' + encodeURIComponent(variantID);
    if(!vendorApproved) {
      url += '?preview=1'
    }
    return this.http.get<ProductDetailResponse>(url, { headers: this.getAuthorizationHeader() });
  }

  getWheelDetailMoreSize(id, variantID, type) {
    const url = environment.apiPath + 'product-more-sizes/' + id + '/' + variantID + '/' + type;
    return this.http.get<any>(url, { headers: this.getAuthorizationHeader() });
  }

  myAccount(): Observable<MyAccountResponse> {
    const url = environment.apiPath + 'profile';
    return this.http.post<MyAccountResponse>(url, "", { headers: this.getAuthorizationHeader() });
  }

  profileFilesUpdate(formData: object): Observable<any> {
    const url = environment.apiPath + 'update-profile-files';
    return this.http.post<any>(url, formData, { headers: this.getAuthorizationHeader() });
  }

  removeProfileFiles(type): Observable<any> {
    const url = environment.apiPath + 'remove-profile-files';
    return this.http.post<any>(url, { type }, { headers: this.getAuthorizationHeader() });
  }

  getInventoryByProduct(product_data): Observable<any> {
    const url = environment.apiPath + 'product/inventory';
    return this.http.post<any>(url, product_data, { headers: this.getAuthorizationHeader() });
  }

  getAddonByAccessory(accessory_id): Observable<any> {
    const url = environment.apiPath + `add-on/${accessory_id}`;
    return this.http.get<any>(url, { headers: this.getAuthorizationHeader() });
  }

  updatePofileSettings(profile_data): Observable<any> {
    const url = environment.apiPath + 'update-settings';
    return this.http.post<any>(url, profile_data, { headers: this.getAuthorizationHeader() });
  }

  getBrands(): Observable<any> {
    const url = environment.apiPath + 'brands';
    return this.http.get<any>(url, { headers: this.getAuthorizationHeader() });
  }


  getAllBrands(params): Observable<any> {
    const queryParams = qs.stringify(params);
    const url = environment.apiPath + 'all-brands' + queryParams;
    return this.http.get<any>(url, { headers: this.getAuthorizationHeader() });
  }

  getAllBrandProducts(params, brand): Observable<any> {
    const queryParams = qs.stringify(params);
    const url = environment.apiPath + 'all-brand-products/' + brand + queryParams;
    return this.http.get<any>(url, { headers: this.getAuthorizationHeader() });
  }

  getAllBrandProductVariants(params, brand, productSlug): Observable<any> {
    const queryParams = qs.stringify(params);
    const url = environment.apiPath + 'all-brand-products/' + brand + '/' + productSlug + queryParams;
    return this.http.get<any>(url, { headers: this.getAuthorizationHeader() });
  }

  getProductMoreSizes(id, type) {
    const url = environment.apiPath + 'brand-product-more-sizes/' + id + '/' + type;
    return this.http.get<any>(url, { headers: this.getAuthorizationHeader() });
  }

  profileUpdate(formData: object): Observable<any> {
    const url = environment.apiPath + 'update-profile';
    return this.http.post<any>(url, formData, { headers: this.getAuthorizationHeader() });
  }
  changePassword(formData: object): Observable<any> {
    const url = environment.apiPath + 'dealer/change-password';
    return this.http.put<any>(url, formData, { headers: this.getAuthorizationHeader() });
  }

  addAddressBook(formData: object): Observable<{ status: boolean, message: string, data: AddressBook }> {
    const url = environment.apiPath + 'address-book/add';
    return this.http.post<{ status: boolean, message: string, data: AddressBook }>(url, formData, { headers: this.getAuthorizationHeader() });
  }

  updateAddressBook(formData: object, id: number): Observable<{ status: boolean, message: string, data: AddressBook }> {
    const url = environment.apiPath + 'address-book/' + id + '/update';
    return this.http.put<{ status: boolean, message: string, data: AddressBook }>(url, formData, { headers: this.getAuthorizationHeader() });
  }

  deleteAddressBook(id: number): Observable<any> {
    const url = environment.apiPath + 'address-book/' + id + '/delete';
    return this.http.delete<any>(url, { headers: this.getAuthorizationHeader() });
  }

  deleteWishlist(id: number): Observable<any> {
    const url = environment.apiPath + 'wishlist/' + id + '/delete';
    return this.http.delete<any>(url, { headers: this.getAuthorizationHeader() });
  }

  myAddressBook(): Observable<{ status: boolean, message: string, data: AddressBook[] }> {
    const url = environment.apiPath + 'address-book/all';
    return this.http.get<{ status: boolean, message: string, data: AddressBook[] }>(url, { headers: this.getAuthorizationHeader() });
  }

  usStates(): Observable<any> {
    const url = environment.apiPath + 'states/us';
    return this.http.get<any>(url, { headers: this.getAuthorizationHeader() });
  }

  getCountries(): Observable<any> {
    const url = environment.apiPath + 'countries';
    return this.http.get<any>(url, { headers: this.getAuthorizationHeader() });
  }
  getAllUserOrder(supplierId='', limit = 0, page: number | null = null):Observable<any> {
    let url = environment.apiPath + 'order/all' + (limit == 0 ? '' : `?limit=${limit}`);
    const symbol = (limit == 0 ? '?' : `&`);
    url = url + (page == null ? '' : `${symbol}page=${page}`);
    const userData: any = JSON.parse( localStorage.getItem('ts_user_data') || '{}' );
    const formData = {'user_id':userData.user_data.id, 'supplierId':supplierId};
    // if(supplierId != undefined && supplierId != ''){
    //   formData = {'user_id':userData.user_data.id, 'supplierId':supplierId};
    // }
    return this.http.post(url, formData, { headers: this.getAuthorizationHeader() });
  }

  getDealerProducts():Observable<any>{
    const url = environment.apiPath + 'dealer/products';
    return this.http.get(url, { headers: this.getAuthorizationHeader()});
  }

  getDealerInventory():Observable<any>{
    const url = environment.apiPath + 'dealer/products?type=inventory';
    return this.http.get(url, { headers: this.getAuthorizationHeader()});
  }

  updateOrDeleteDealerProducts(updateList: any[], deleteList: any[], addList: any[]): Observable<any> {
    const url = environment.apiPath + 'dealer/products/bulk/add-update-grid';
    const formData = new FormData();
  
    // Handle updates
    updateList.forEach((product, index) => {
      Object.keys(product.newRow).forEach(key => {
        formData.append(`list[updateList][${index}][${key}]`, product.newRow[key] !== null  && product.newRow[key] !== undefined ? product.newRow[key].toString() : '');
      });
  
      const oldRowKey = Object.keys(product.oldRow)[0];
      const oldRowValue = product.oldRow[oldRowKey];
      formData.append(`list[oldList][${index}][${oldRowKey}]`, oldRowValue !== null && oldRowValue !== undefined ? oldRowValue.toString() : '');
    });
  
    // Handle deletions
    deleteList.forEach((product, index) => {
      Object.keys(product).forEach(key => {
        formData.append(`list[deleteList][${index}][${key}]`, product[key] !== null && product[key] !== undefined  ? product[key].toString() : '');
      });
    });
  
    // Handle additions
    addList.forEach((product, index) => {
      Object.keys(product).forEach(key => {
        formData.append(`list[addList][${index}][${key}]`, product[key] !== null && product[key] !== undefined ? product[key].toString() : '');
      });
    });
  
    return this.http.post(url, formData, { 
      headers: this.getAuthorizationHeader()
    }).pipe(
      timeout(60000) // 60 seconds timeout for bulk operations
    );
  }

  updateOrDeleteDealerInventory(updateList: any[],warehouse:any): Observable<any> {
    // ✅ Production debugging: Log environment and all parameters
    console.log('🌍 [API] Environment Info:');
    console.log('   - environment.production:', environment.production);
    console.log('   - environment.apiPath:', environment.apiPath);
    console.log('   - environment.basePath:', environment.basePath);
    
    console.log('🔍 [API] updateOrDeleteDealerInventory called with:');
    console.log('   - updateList:', updateList);
    console.log('   - updateList.length:', updateList?.length);
    console.log('   - warehouse:', warehouse);
    console.log('   - warehouse?.id:', warehouse?.id);
    
    // ✅ Check localStorage and authentication
    const token = localStorage.getItem('ts_vendor_access_token');
    console.log('🔑 [API] Authentication:');
    console.log('   - token exists:', !!token);
    console.log('   - token preview:', token?.substring(0, 20) + '...');
    
    // ✅ Validation: Check if warehouse exists
    if (!warehouse || !warehouse.id) {
      console.error('❌ [API] Warehouse is missing or invalid:', warehouse);
      console.error('❌ [API] This will prevent the API call from being made');
      throw new Error('Warehouse information is required for inventory updates');
    }
    
    // ✅ Validation: Check if updateList exists and has items
    if (!updateList || updateList.length === 0) {
      console.error('❌ [API] UpdateList is empty or invalid:', updateList);
      throw new Error('No items to update');
    }
    
    const url = environment.apiPath + 'dealer/products/inventory-update';
    console.log('🔗 [API] Request URL:', url);
    console.log('🔗 [API] Full URL will be:', url);
    
    const formData = new FormData();
  
    // Handle updates
    updateList.forEach((product, index) => {
      console.log(`📦 [API] Processing item ${index + 1}/${updateList.length}:`, product);
      
      formData.append(`list[updateList][${index}][productId]`, product.newRow['product_id'] !== null  && product.newRow['product_id'] !== undefined ? product.newRow['product_id'].toString() : '');
      formData.append(`list[updateList][${index}][product_full_name]`, product.newRow['product_full_name'] !== null  && product.newRow['product_full_name'] !== undefined ? product.newRow['product_full_name'].toString() : '');
      formData.append(`list[updateList][${index}][id]`, product.newRow['id'] !== null  && product.newRow['id'] !== undefined ? product.newRow['id'].toString() : '');
      formData.append(`list[updateList][${index}][total_quantity]`, product.newRow['total_quantity'] !== null  && product.newRow['total_quantity'] !== undefined ? product.newRow['total_quantity'].toString() : '');
      formData.append(`list[updateList][${index}][sku]`, product.newRow['sku'] !== null  && product.newRow['sku'] !== undefined ? product.newRow['sku'].toString() : '');
      formData.append(`list[updateList][${index}][size]`, product.newRow['size'] !== null  && product.newRow['size'] !== undefined ? product.newRow['size'].toString() : '');
      formData.append(`list[updateList][${index}][bolt_pattern]`, product.newRow['bolt_pattern'] !== null  && product.newRow['bolt_pattern'] !== undefined ? product.newRow['bolt_pattern'].toString() : '');
      formData.append(`list[updateList][${index}][offset]`, product.newRow['offset'] !== null  && product.newRow['offset'] !== undefined ? product.newRow['offset'].toString() : '');
      formData.append(`list[updateList][${index}][quantity]`, product.newRow['quantity'] !== null  && product.newRow['quantity'] !== undefined ? product.newRow['quantity'].toString() : '');

      formData.append(`list[updateList][${index}][inventory][0][warehouse_id]`, warehouse?.id);
      formData.append(`list[updateList][${index}][inventory][0][product_id]`, product?.newRow?.product_id);
      formData.append(`list[updateList][${index}][inventory][0][product_variant_id]`, product?.newRow?.product_variant_id);
      formData.append(`list[updateList][${index}][inventory][0][add_on_id]`, product?.newRow?.add_on_id);
      formData.append(`list[updateList][${index}][inventory][0][quantity]`, product?.newRow?.variant_quantity);
      formData.append(`list[updateList][${index}][inventory][0][eta]`, product?.newRow?.eta);
      formData.append(`list[updateList][${index}][inventory][0][eta_qty]`, product?.newRow?.eta_qty);

      Object.keys(warehouse).forEach(warehouseKey => {
        formData.append(
          `list[updateList][${index}][inventory][0][warehouse][${warehouseKey}]`,
          warehouse[warehouseKey] !== null && warehouse[warehouseKey] !== undefined ? warehouse[warehouseKey].toString() : ''
        );
      });
  
      const oldRowKey = Object.keys(product.oldRow)[0];
      const oldRowValue = product.oldRow[oldRowKey];
      formData.append(`list[oldList][${index}][${oldRowKey}]`, oldRowValue !== null && oldRowValue !== undefined ? oldRowValue.toString() : '');
    });
    
    console.log('🚀 [API] About to make POST request to:', url);
    console.log('🚀 [API] FormData prepared, making HTTP call...');
    
    return this.http.post(url, formData, { 
      headers: this.getAuthorizationHeader()
    }).pipe(
      timeout(60000) // 60 seconds timeout for inventory updates
    );
  }
  
  

  bulkDeleteDealerProducts(deleteIds: number[]): Observable<any> {
    const url = environment.apiPath + 'dealer/products/bulk/delete-grid';
    const formData = new FormData();
    deleteIds.forEach(id => {
      formData.append('deleteIds[]', id.toString());
    });
    return this.http.post(url, formData, { headers: this.getAuthorizationHeader() });
  }
  
  
  uploadDealerProducts(formData: FormData): Observable<any> {
    const url = environment.apiPath + 'dealer/products/upload';
    return this.http.post(url, formData, { headers: this.getAuthorizationHeader() });
  }

  // ✅ HYBRID BATCH PROCESSING: Async product upload for large CSV files
  uploadDealerProductsAsync(formData: FormData): Observable<any> {
    const url = environment.apiPath + 'dealer/products/upload-async';
    return this.http.post(url, formData, { headers: this.getAuthorizationHeader() });
  }

  uploadDealerInventory(formData: FormData): Observable<any> {
    const url = environment.apiPath + 'dealer/products/upload-inventory';
    return this.http.post(url, formData, { headers: this.getAuthorizationHeader() });
  }

  // ✅ HYBRID BATCH PROCESSING: Async upload for large CSV files
  uploadDealerInventoryAsync(formData: FormData): Observable<any> {
    const url = environment.apiPath + 'dealer/products/upload-inventory-async';
    return this.http.post(url, formData, { headers: this.getAuthorizationHeader() });
  }

  // ✅ HYBRID BATCH PROCESSING: Check job status for async uploads
  getJobStatus(jobId: string): Observable<any> {
    const url = environment.apiPath + `dealer/products/job-status/${jobId}`;
    return this.http.get(url, { headers: this.getAuthorizationHeader() });
  }

  // ✅ IMAGE UPLOAD: Bulk upload dealer product images
  uploadDealerProductImages(productImages: any[]): Observable<any> {
    const url = environment.apiPath + 'dealer/products/bulk-images-upload';
    const formData = new FormData();
    productImages.forEach(file => {
      formData.append('product_images[]', file, file.name);
    });
    return this.http.post(url, formData, { headers: this.getAuthorizationHeader() });
  }

  downloadSearchProducts(queryParams:any) : Observable<any> {
    const url = environment.apiPath + 'products/download';
    const paramsCopy = { ...queryParams };
    delete paramsCopy.perPage;
    const queryString = new URLSearchParams(paramsCopy).toString();
    const finalUrl = `${url}?${queryString}`;
    return this.http.get(finalUrl, { headers: this.getAuthorizationHeader(), responseType: 'blob' });
  }

  filterUserOrders(body, page:number):Observable<any> {
    let url = environment.apiPath + 'order/all?limit=6&page='+page;
    return this.http.post(url, body, { headers: this.getAuthorizationHeader() });
  }

  getOrderInvoiceFileContent(order_id:number):Observable<any>{
    let url = environment.apiPath + 'order/download-invoice/'+order_id;
    return this.http.get(url, { headers: this.getAuthorizationHeader(), responseType: 'blob' });
  }
  getUserInvoices(supplierId = ''): Observable<any> {
    const url = environment.apiPath + 'order/all-order-invoices';
    const userData: any = JSON.parse(localStorage.getItem('ts_user_data') || '{}');
    const formData = { 'user_id': userData.user_data.id, 'supplierId': supplierId };
    // if(supplierId != undefined && supplierId != ''){
    //   formData = {'user_id':userData.user_data.id, 'supplierId':supplierId};
    // }
    return this.http.post(url, formData, { headers: this.getAuthorizationHeader() });
  }
  getUserOrderInvoices(supplierId = ''): Observable<any> {
    const url = environment.apiPath + 'order/get-invoice';
    const userData: any = JSON.parse(localStorage.getItem('ts_user_data') || '{}');
    const formData = { 'user_id': userData.user_data.id, 'supplierId': supplierId };
    // if(supplierId != undefined && supplierId != ''){
    //   formData = {'user_id':userData.user_data.id, 'supplierId':supplierId};
    // }
    return this.http.post(url, formData, { headers: this.getAuthorizationHeader() });
  }

  // ----------------------------------------------------------
  // ----------------------------------------------------------
  // ----------------------------------------------------------
  // ----------------------------------------------------------

  getMakes(): Observable<any> {
    // Use secure backend proxy instead of direct third-party API call (public route)
    const url = environment.apiPath + 'vehicle-search/makes';
    return this.http.get(url);
  }
  getModels(make: string): Observable<any> {
    // Use secure backend proxy instead of direct third-party API call (public route)
    const url = environment.apiPath + 'vehicle-search/models';
    const params = { make };
    return this.http.get(url, { params });
  }
  getYear(make: string, model: string): Observable<any> {
    // Use secure backend proxy instead of direct third-party API call (public route)
    const url = environment.apiPath + 'vehicle-search/years';
    const params = { make, model };
    return this.http.get(url, { params });
  }
  
  getModifications(make: string, model: string, year: string): Observable<any> {
    // Use secure backend proxy instead of direct third-party API call (public route)
    const url = environment.apiPath + 'vehicle-search/modifications';
    const params = { make, model, year };
    return this.http.get(url, { params });
  }

  getVehicles(formData: any): Observable<any> {
    // Use secure backend proxy instead of direct third-party API call (public route)
    const url = environment.apiPath + 'vehicle-search/search';
    return this.http.get(url, { params: formData });
  }

  // getVehicles = (formData: any) => {
  //   formData.user_key = environment.wheel_user_key;
  //   const query = qs.stringify(formData);
  //   const url = environment.wheelApiPath + 'vehicles/?' + query;
  //   return this.http.get(url);
  // }

  searchVehicles(formData: any, pagination = 1, uniqueSize = 0): Observable<any> {
    const url = environment.apiPath + 'search-vehicles?pagination=' + pagination + '&uniqueSize=' + uniqueSize;
    return this.http.post<any>(url, formData);
  }


  searchSize(formData: any): Observable<any> {
    const url = environment.apiPath + 'search-sizes';
    return this.http.post<any>(url, formData, { headers: this.getAuthorizationHeader() });
  }
  getWheelFits = (queryString: any) => {
    // Use secure backend proxy instead of direct third-party API call (public route)
    const url = environment.apiPath + 'vehicle-search/wheel-fits';
    
    // If queryString is a string, parse it into an object
    let params = queryString;
    if (typeof queryString === 'string') {
      const urlParams = new URLSearchParams(queryString);
      params = {};
      urlParams.forEach((value, key) => {
        params[key] = value;
      });
    }
    
    return this.http.get(url, { params: params });
  }

  searchWheels(formData: any): Observable<Wheels> {
    const query = qs.stringify(formData);
    const url = environment.apiPath + 'filter-wheels?' + query;
    return this.http.get<Wheels>(url, { headers: this.getAuthorizationHeader() });
  }

  searchSizeParams(): Observable<any> {
    const url = environment.apiPath + 'search-form-params';
    return this.http.get<any>(url, { headers: this.getAuthorizationHeader() });
  }


  getUserLocation(): Observable<any> {
    const url = 'https://extreme-ip-lookup.com/json/';
    return this.http.get(url);
  }

  addToCart(formData: any): Observable<any> {
    const url = environment.apiPath + 'cart/add';
    return this.http.post<any>(url, formData, { headers: this.getAuthorizationHeader() });
  }

  getCart(): Observable<CartResponse> {
    const session_id = localStorage.getItem('session_id');
    const url = environment.apiPath + 'cart/' + session_id + '/get';
    return this.http.get<CartResponse>(url, { headers: this.getAuthorizationHeader() });
  }

  changeWareouseQuantity(formData: object): Observable<CartResponse> {
    const url = environment.apiPath + 'cart/change-quantity';
    return this.http.post<CartResponse>(url, formData, { headers: this.getAuthorizationHeader() });
  }

  changeQuantity(formData: object): Observable<CartResponse> {
    const url = environment.apiPath + 'cart/change-quantity';
    return this.http.post<CartResponse>(url, formData, { headers: this.getAuthorizationHeader() });
  }

  deleteCartItem(itemId: number): Observable<CartResponse> {
    const url = environment.apiPath + 'cart/' + itemId + '/delete';
    return this.http.delete<CartResponse>(url, { headers: this.getAuthorizationHeader() });
  }

  socialLogin(formData: object): Observable<UserResponse> {
    const url = environment.apiPath + 'auth/social-login';
    return this.http.post<UserResponse>(url, formData);
  }

  getAddsOnByProduct(prodId: number): Observable<any> {
    const url = environment.apiPath + 'addons/' + prodId;
    return this.http.get<any>(url, { headers: this.getAuthorizationHeader() });
  }

  notifyAddonsWhenAvailable(addonId: any): Observable<any>{
    const url = environment.apiPath + 'dealer/notify/restock-addon/' + addonId;
    return this.http.get(url, { headers: this.getAuthorizationHeader() });
  }

  homepage(): Observable<any> {
    const url = environment.apiPath + 'homepage';
    return this.http.get(url);
  }

  payformUI(formData: any): Observable<any> {
    const url = environment.apiPath + 'payment';
    return this.http.post(url, formData);
  }

  processOrder(params): Observable<any> {
    const queryParams = qs.stringify(params);
    const url = environment.apiPath + 'order/process?' + queryParams;
    return this.http.get(url, { headers: this.getAuthorizationHeader() });
  }

  placeOrder(orderData: any, vendorData): Observable<any> {
    const { billing, shipping, ...rest } = orderData || {}
    const formData = new FormData();
    const url = environment.apiPath + 'order/store';

    formData.append("billing[first_name]", billing["first_name"])
    formData.append("billing[last_name]", billing["last_name"])
    formData.append("billing[country]", billing["country"])
    formData.append("billing[address]", billing["address"])
    formData.append("billing[phone]", billing["phone"])
    formData.append("billing[email]", billing['email'])
    formData.append("billing[order_id]", billing["order_id"])
    formData.append("billing[city]", billing["city"])
    formData.append("billing[zip_code]", billing["zip_code"])
    formData.append("shipping[first_name]", shipping["first_name"])
    formData.append("shipping[last_name]", shipping["last_name"])
    formData.append("shipping[country]", shipping["country"])
    formData.append("shipping[address]", shipping["address"])
    formData.append("shipping[phone]", shipping["phone"])
    formData.append("shipping[email]", shipping["email"])
    formData.append("shipping[order_id]", shipping["order_id"])
    formData.append("shipping[city]", shipping["city"])

    delete orderData.store_address;
    for (const key in rest) {
      if (orderData[key]) {
        formData.append(key, typeof orderData[key] === "boolean" ? orderData ? "1" : "0" : orderData[key]);
      }
    }

    vendorData.map((vendor, index) => {
      formData.append('shipping_files[' + index + '][vendor_id]', vendor?.vendor_id);
      formData.append('shipping_files[' + index + '][file]', vendor?.file);
    })

    return this.http.post(url, formData, { headers: this.getAuthorizationHeader() });
  }

  confirmOrder(OrderId: number): Observable<any> {
    const url = environment.apiPath + 'order/completed';
    let formData = { "order_id": OrderId };
    return this.http.post(url, formData, { headers: this.getAuthorizationHeader() });
  }

  updateOrder(formData: any, cartId): Observable<any> {
    const url = environment.apiPath + 'order/update/' + cartId;
    return this.http.put(url, formData, { headers: this.getAuthorizationHeader() });
  }

  getOrder(): Observable<OrderResponse> {
    const url = environment.apiPath + 'order/' + localStorage.getItem('session_id') + '/get';
    return this.http.get<OrderResponse>(url, { headers: this.getAuthorizationHeader() });
  }

  getOrderById(orderId): Observable<OrderResponse> {
    const url = environment.apiPath + 'order/getById/' + orderId;
    return this.http.get<OrderResponse>(url, { headers: this.getAuthorizationHeader() });
  }

  applyCoupon(formData: any): Observable<any> {
    const url = environment.apiPath + 'coupon/apply';
    return this.http.post<any>(url, formData, { headers: this.getAuthorizationHeader() });
  }

  addProductReview(formData: any): Observable<any> {
    const url = environment.apiPath + 'product-review/add';
    return this.http.post<any>(url, formData, { headers: this.getAuthorizationHeader() });
  }

  // calculateShipping(country: string, cartId: number): Observable<CartResponse> {
  //   const url = environment.apiPath + 'calculate-shipping/' + country + '/' + cartId;
  //   return this.http.get<CartResponse>(url, {headers: this.getAuthorizationHeader()});
  // }

  calculateShipping(shippingOptions: string, cartId: number): Observable<CartResponse> {
    const url = environment.apiPath + 'calculate-shipping/' + shippingOptions + '/' + cartId;
    return this.http.get<CartResponse>(url, { headers: this.getAuthorizationHeader() });
  }

  checkoutOptions(vendor_id = null): Observable<any> {
    let url = environment.apiPath + 'checkout-options';
    if (vendor_id) {
      url += `?vendor_id=${vendor_id}`
    }
    return this.http.get<CartResponse>(url, { headers: this.getAuthorizationHeader() });
  }

  addWishlist(formData: any): Observable<any> {
    // const headers = this.getH
    const url = environment.apiPath + 'wishlist/add';
    return this.http.post<any>(url, formData, { headers: this.getAuthorizationHeader() });
  }



  search(query: any): Observable<SearchInterface> {
    const url = environment.apiPath + 'search?query=' + query;
    return this.http.get<SearchInterface>(url, { headers: this.getAuthorizationHeader() });
  }



  /** Pages Api starts Here. */
  /**
  * @method getPrivacyPolicy
  * @param @void
  * @return Any
  */
  getPrivacyPolicy(): Observable<any> {
    const url = environment.apiPath + 'page/privacy-policy';
    return this.http.get<any>(url);
  }

  /**
  * @method getFooterPage
  * @param pageUrl
  * @return Any
  */
  getFooterPage(pageUrl: any): Observable<any> {
    const url = environment.apiPath + 'page/' + pageUrl;
    return this.http.get<any>(url);
  }


  /** Pages Api Ends Here. */






  // MyTODO: Remove it later
  addonsAddToCart(formData: any): Observable<any> {
    const url = environment.apiPath + 'cart/add-addon';
    return this.http.post<any>(url, formData, { headers: this.getAuthorizationHeader() });
  }

  addonsRemoveFromCart(addOnId: any): Observable<any> {
    const url = environment.apiPath + 'cart/' + addOnId + '/delete-addon';
    return this.http.delete<any>(url, { headers: this.getAuthorizationHeader() });
  }

  changeAddonQuantity(formData: object): Observable<CartResponse> {
    const url = environment.apiPath + 'cart/add-on-change-quantity';
    return this.http.post<CartResponse>(url, formData, { headers: this.getAuthorizationHeader() });
  }

  homepageGallery(): Observable<any> {
    const url = environment.apiPath + 'gallery';
    return this.http.get(url);
  }

  deleteAllCartItem(): Observable<any> {
    const url = environment.apiPath + 'cart/clear/' + localStorage.getItem('session_id');
    return this.http.delete<any>(url, { headers: this.getAuthorizationHeader() });
  }

  sendFbPurchaseEvent(orderId): Observable<any> {
    const url = environment.apiPath + 'send-purchase-event';
    return this.http.post(url, { order_id: orderId }, { headers: this.getAuthorizationHeader() });
  }

  PaymentWithPostPay(): Observable<any> {
    const url = environment.apiPath + 'payment';
    return this.http.post(url, { gateway: 'PostPay', session_id: localStorage.getItem('session_id') });
  }

  PaymentWithStripe(token: any): Observable<any> {
    const url = environment.apiPath + 'order/payment';
    return this.http.post(url, { gateway: 'Stripe', session_id: localStorage.getItem('session_id'), stripeToken: token }, {headers: this.getAuthorizationHeader()});
  }


  vendorsDownloadListing(queryString = null): Observable<any> {
    let url = environment.apiPath + 'my-vendors';
    if (queryString != null) {
      url += '?vendor_name=' + queryString;
    }

    return this.http.get<any>(url, { headers: this.getAuthorizationHeader() });
  }

  setHeaders() {
    let header = new HttpHeaders().set('Authorization', 'Bearer ' + localStorage.getItem('ts_vendor_access_token'));;
    header = header.set('Content-Type', 'application/json');
    header = header.set('Accept', 'application/json');
    header = header.set('responseType', 'json as blob');
    return header;
  }

  vendorFileDownload(vendorId: number): Observable<any> {
    const url = environment.apiPath + 'vendor-data/' + vendorId;
    // window.location.href = url;
    return this.http.get<any>(url, { headers: this.setHeaders() });
  }


  getApiKeyIntegration(): Observable<any> {
    let url = environment.apiPath + 'get-api-credentials';
    return this.http.get<any>(url, { headers: this.getAuthorizationHeader() });
  }

  getIntegrationAuthorizationHeader(): HttpHeaders {
    return new HttpHeaders().set('Authorization', 'Bearer ' + localStorage.getItem('ts_vendor_api_key'));
  }

  getBrandIntegration(): Observable<any> {
    const url = environment.apiPath + 'v1/brands';
    return this.http.get<any>(url, { headers: this.getIntegrationAuthorizationHeader() });
  }

  getProductsIntegration(): Observable<any> {
    const url = environment.apiPath + 'v1/products';
    return this.http.get<any>(url, { headers: this.getIntegrationAuthorizationHeader() });
  }

  getSupplierProducts(params, supplierId, product = '', isVendorApproved = true): Observable<any> {
    const queryParams = qs.stringify(params);
    let url = environment.apiPath + 'get-supplier-products/' + supplierId;//+queryParams;
    if (product != undefined && product != '') {
      url = url + '/' + product;
    }
    url += '?supplierProduct=1'
    if (!isVendorApproved) {
       url += '&preview=1'
    }
    return this.http.get<any>(url, { headers: this.getAuthorizationHeader() });
  }

  getProductBySKU(sku): Observable<any> {
    let url = environment.apiPath + 'product/' + sku;
    return this.http.get<any>(url, { headers: this.getAuthorizationHeader() });
  }

  getSupplierProductsVariants(supplierId, product, diameter): Observable<any> {
    // const queryParams = qs.stringify(params);
    const url = environment.apiPath + 'get-product-more-sizes/' + supplierId + '/' + product + '/' + diameter;//+queryParams;
    return this.http.get<any>(url, { headers: this.getAuthorizationHeader() });
  }
  getPlans() {
    return this.http.get<any>(`${environment.apiPath}plans/get`, { headers: this.getAuthorizationHeader() });
  }

  getBillingStatus() {
    return this.http.get<any>(`${environment.apiPath}plans/billing-status`, { headers: this.getAuthorizationHeader() });
  }

  changePlan(planSlug: string) {
    return this.http.post<any>(`${environment.apiPath}plans/change`, { planSlug }, { headers: this.getAuthorizationHeader() });
  }

  cancelPlan(planSlug: string) {
    return this.http.post<any>(`${environment.apiPath}plans/cancel`, { planSlug }, { headers: this.getAuthorizationHeader() });
  }

  getAddOnCategories(): Observable<any> {
    const url = environment.apiPath + 'add-ons/categories';
    return this.http.get<any>(url, { headers: this.getAuthorizationHeader() });
  }

  getAddOnsByCategory(slug: string, queryParams = {}): Observable<any> {
    const url = environment.apiPath + `add-ons/${slug}/get`;
    return this.http.get<any>(url, { headers: this.getAuthorizationHeader(), params: queryParams });
  }

  getAddOnDetail(category: string, sku: string, id: number, queryParams = {}): Observable<any> {
    const url = environment.apiPath + `add-ons/${category}/get/${sku}/${id}/details`;
    return this.http.get<any>(url, { headers: this.getAuthorizationHeader(), params: queryParams });
  }

  getCartOrders(cartId: number): Observable<any> {
    const url = environment.apiPath + `cart/${cartId}/getorders`;
    return this.http.get<any>(url, { headers: this.getAuthorizationHeader() });
  }

  notifyAddToCart(variantID): Observable<any> {
    const url = environment.apiPath + `dealer/notify-cart/${variantID}`;
    return this.http.get<any>(url, { headers: this.getAuthorizationHeader() });
  }  allVendors(formData: any = null, pagination = 1): Observable<any> {
    const params = formData || {};
    params.pagination = pagination;
    let url = environment.apiPath + 'dealer/all-vendors';
    return this.http.get(url, { params: params, headers: this.getAuthorizationHeader() });
  }

  // ✅ CONFIGURATION: Get upload configuration from backend
  getUploadConfig(): Observable<any> {
    const url = environment.apiPath + 'dealer/products/upload-config';
    return this.http.get(url, { headers: this.getAuthorizationHeader() });
  }
}
